import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ContainerVisitService } from '@common/services/container-visit.service';
import { ModalService } from '@common/services/modal.service';
import { marker } from '@common/translate-marker';
import { TranslateService } from '@ngx-translate/core';
import { DialogCloseResult, DialogRef } from '@progress/kendo-angular-dialog';
import { ToastService } from '@services/toast.service';
import { UnconfirmMovesDisplayModel } from 'app/cargo-operations/models/UnconfirmMoves.display.model';
import { filter } from 'rxjs';

@Component({
    selector: 'app-unconfirm-moves-modal',
    templateUrl: './unconfirm-moves-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnconfirmMovesModalComponent implements OnInit {
    title: string;
    message: string;
    manipulation: string;
    containerItemIds: any[];
    serviceRequestId: number | null = null;

    model: UnconfirmMovesDisplayModel = new UnconfirmMovesDisplayModel();
    form: UntypedFormGroup;

    constructor(
        public activeModal: DialogRef,
        private dialogService: ModalService,
        private translateService: TranslateService,
        private toastyService: ToastService,
        private service: ContainerVisitService
    ) {}

    ngOnInit() {
        this.form = this.model.createFormGroup();
        this.form.get('containerCount').patchValue(this.containerItemIds.length);
        this.form.get('serviceRequestId').patchValue(this.serviceRequestId);
        this.form.get('manipulation').patchValue(this.manipulation);
    }

    clear() {
        this.form.reset();
    }

    unconfirm() {
        this.dialogService
            .confirm(
                this.translateService.instant(marker('Unconfirm selected container moves?')),
                this.translateService.instant(marker('Are you sure you want to remove selected container moves?')),
                this.translateService.instant(marker('YES')),
                null,
                this.translateService.instant(marker('No'))
            )
            .pipe(filter((x) => !(x instanceof DialogCloseResult)))
            .subscribe((dialogResult) => {
                if (dialogResult) {
                    const body = {
                        serviceRequestId: this.serviceRequestId,
                        remark: this.form.get('remark').value,
                        versionContainerIds: this.containerItemIds
                    };
                    this.service
                        .uncofirmContainerMoves(body)
                        .pipe()
                        .subscribe({
                            next: () => {
                                this.activeModal.close(body);
                            }
                        });
                }
            });
    }
}
